import { Form } from "antd"
import { type FormInstance } from "antd/es/form/hooks/useForm"
import React, { type Ref } from "react"

import { type DocumentScopeSectionProjectTypes } from "../../../../types/document.types.ts"
import type { TemplateDocumentFormData } from "../../../../types/template-document-form-data.tsx"
import {
  type DocumentScopeSectionListRef,
  ScopeOfWorkBlockList
} from "./ScopeOfWorkBlockList.tsx"

interface ScopeOfWorkBlockProps {
  form: FormInstance<TemplateDocumentFormData>
  index: number
  listRef: Ref<DocumentScopeSectionListRef>
  projectTypes: DocumentScopeSectionProjectTypes
  disabled?: boolean
}

export function ScopeOfWorkBlock({
  form,
  index,
  listRef,
  projectTypes,
  disabled
}: ScopeOfWorkBlockProps) {
  const columnKey: keyof TemplateDocumentFormData = "phases"

  return (
    <>
      {/*<Form.Item name={["detailedScope", "description"]} label="Info">*/}
      {/*  <TextInput placeholder="All work to be performed according to industry standards and California Building Code." />*/}
      {/*</Form.Item>*/}
      <Form.List name={columnKey}>
        {(fields, operations) => (
          <ScopeOfWorkBlockList
            form={form}
            index={index}
            listRef={listRef}
            fields={fields}
            columnKey={columnKey}
            disabled={disabled}
            operations={operations}
            projectTypes={projectTypes}
          />
        )}
      </Form.List>
    </>
  )
}
